import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDMXyV-1dctjphs89E0RYfJixD62gHRkE8",
    authDomain: "wally-web.firebaseapp.com",
    projectId: "wally-web",
    storageBucket: "wally-web.appspot.com",
    messagingSenderId: "663880160924",
    appId: "1:663880160924:web:6e6bcaa19935ee9c693f59",
    measurementId: "G-2W6179SV39"
  };
  
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);

  const sendEvent = (event: string) => {
    logEvent(analytics, event);
  }

export {sendEvent};